// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__oA+ky","active":"Modal_active__W0BX5","modal_content":"Modal_modal_content__U9Vxb","closeButtonMobile":"Modal_closeButtonMobile__APL+o"};